import http from './httpService';
import {encodeQueryData} from '../../Utils/Common';
const API_URL_TARGET = process.env.REACT_APP_API_URL_TARGET;

async function getAllOpenTender(params:any) {
    const url = `${API_URL_TARGET}get_all_tenders?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

async function revertTender(params:any) {
    const url = `${API_URL_TARGET}delete_tender/`+params;
    let response = await http.delete(url);
    return response;
}

async function updateTender(params:any,obj:any) {
    const url = `${API_URL_TARGET}update_tender/`+params;
    let response = await http.put(url, obj);
    return response;
}

const TenderServices = {
    getAllOpenTender,
    revertTender,
    updateTender
};

export default TenderServices;